import { useEffect, useState } from 'react'

/**
 * Loads once on mount; `data` stays null until resolved, `error` carries the message on failure.
 * Pass a stable module-level loader (e.g. `api.leaderboard`) — it is intentionally not a dependency.
 */
export function useFetch<T>(load: () => Promise<T>) {
  const [data, setData] = useState<T | null>(null)
  const [error, setError] = useState<string | null>(null)
  // biome-ignore lint/correctness/useExhaustiveDependencies: run once; loader is stable by contract
  useEffect(() => {
    let cancelled = false
    load()
      .then((d) => {
        if (!cancelled) setData(d)
      })
      .catch((err) => {
        if (!cancelled) setError((err as Error).message)
      })
    return () => {
      cancelled = true
    }
  }, [])
  return { data, error }
}
